import { lazyRetry } from '~/utils/lazyRetry'
import { ADMIN_ROUTES, EMAIL_MARKETING_ROUTES } from '~/constants/router'
import { emailMarketingRolesCS } from '~/modules/auth/conditions'
import { FLAGS } from '~/constants/flags'

const EmailMarketingDashboard = lazyRetry(
  () => import('~/pages/EmailMarketing'),
)
const EmailMarketingWorkflows = lazyRetry(
  () => import('~/pages/EmailMarketing/Workflows/List'),
)
const EmailMarketingCreateWorkflow = lazyRetry(
  () => import('~/pages/EmailMarketing/Workflows/CreateWorkflow'),
)
const EmailMarketingWorkflowDetail = lazyRetry(
  () => import('~/pages/EmailMarketing/Workflows/Detail'),
)
const EmailMarketingCreateTemplate = lazyRetry(
  () =>
    import(
      '~/pages/EmailMarketing/Templates/CreateEmailTemplate/CreateEmailTemplateWrapper'
    ),
)
const EmailMarketingEditTemplate = lazyRetry(
  () =>
    import(
      '~/pages/EmailMarketing/Templates/EditEmailTemplate/EditEmailTemplateWrapper'
    ),
)
const EmailMarketingTemplates = lazyRetry(
  () => import('~/pages/EmailMarketing/Templates'),
)
const EmailMarketingQueues = lazyRetry(
  () => import('~/pages/EmailMarketing/Queues'),
)
const EmailMarketingSubscribers = lazyRetry(
  () => import('~/pages/EmailMarketing/Subscribers'),
)

const EmailMarketingRouters = [
  {
    path: EMAIL_MARKETING_ROUTES.DASHBOARD,
    component: EmailMarketingDashboard,
    layout: 'admin',
    exact: true,
    routeName: 'Email Marketing Dashboard',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.WORKFLOWS,
    component: EmailMarketingWorkflows,
    layout: 'admin',
    exact: true,
    routeName: 'Email Marketing Workflows List',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.CREATE_WORKFLOW,
    component: EmailMarketingCreateWorkflow,
    layout: 'admin',
    exact: true,
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
    routeName: 'Create Email Marketing Workflow',
  },
  {
    path: EMAIL_MARKETING_ROUTES.WORKFLOW_DETAIL,
    component: EmailMarketingWorkflowDetail,
    layout: 'admin',
    exact: true,
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
    routeName: 'Email Marketing Workflow Detail',
  },
  {
    path: EMAIL_MARKETING_ROUTES.TEMPLATES,
    component: EmailMarketingTemplates,
    layout: 'admin',
    exact: true,
    routeName: 'Email Marketing Templates',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.CREATE_TEMPLATE,
    component: EmailMarketingCreateTemplate,
    layout: 'admin',
    exact: true,
    routeName: 'Create Email Marketing Template',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.EDIT_TEMPLATE,
    component: EmailMarketingEditTemplate,
    layout: 'admin',
    exact: true,
    routeName: 'Edit Email Marketing Template',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.QUEUES,
    component: EmailMarketingQueues,
    layout: 'admin',
    exact: true,
    routeName: 'Email Marketing Queues',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
  {
    path: EMAIL_MARKETING_ROUTES.OPT_INS,
    component: EmailMarketingSubscribers,
    layout: 'admin',
    exact: true,
    routeName: 'Email Marketing Subscribers',
    bsTheme: true,
    roles: emailMarketingRolesCS,
    featureFlag: FLAGS.CS_8598_EMAIL_MARKETING,
  },
]

export default EmailMarketingRouters
